<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="新建任务">
    </el-page-header>
    <div class="main">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12rem">
        <div class="form-header">
          <el-form-item label="任务名称：" prop="name">
            <el-input clearable style="width: 40rem" v-model="form.name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item label="发送范围：">
            <el-radio-group v-model="form.visible_range">
              <el-radio label="0">全部</el-radio>
              <el-radio label="1">部分人员</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.visible_range == 1">
            <el-form-item label="按成员：">
              <div class="person">
                <el-tag v-for="item of names" style="margin: rem 1.2rem 0 0"  effect="plain" :key="item">
                  {{ item }}
                </el-tag>
              </div>
              <el-button class="addBtn" icon="el-icon-plus" @click="addContact">前往添加</el-button>
            </el-form-item>
            <el-form-item label="按部门：">
              <el-cascader style="width: 40rem" clearable v-model="form.department_list" :options="options" :props="{
                multiple: true,
                emitPath: false,
              }" size="medium" placeholder="请选择部门"></el-cascader>
            </el-form-item>
            <el-form-item label="按客户可见范围：">
              <el-cascader style="width: 40rem" clearable v-model="form.tag_list" :options="optionsTag" :props="{
                multiple: true,
                emitPath: false,
              }" size="medium" placeholder="请选择客户标签"></el-cascader>
            </el-form-item>
          </template>
        </div>
        <div class="form-content">
          <el-form-item label="内容类型:">
            <el-radio-group v-model="form.type" @change="changeTypeContent">
              <el-radio label="图片">图片</el-radio>
              <el-radio label="链接">链接</el-radio>
              <el-radio label="视频">视频</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="内容:" prop="content">
            <el-input style="width: 40rem" clearable type="textarea" autosize="true" placeholder="请输入您想要发表的内容"
              v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '链接'" label="链接标题：" prop="link_title">
            <el-input style="width: 40rem" clearable v-model="form.link_title" placeholder="请输入链接标题"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '链接'" label="url链接" prop="link_url">
            <el-input style="width: 40rem" clearable v-model="form.link_url"
              placeholder="请输入url链接, 如: https://www.weijub.com/"></el-input>
          </el-form-item>
          <el-form-item :label="form.type == '链接' ? '封面:' : '素材:'" prop="media">
            <ul v-if="form.type == '图片' || form.type == '链接'" class="el-upload-list el-upload-list--picture-card">
              <li tabindex="0" class="el-upload-list__item is-ready media-img" v-for="(item, index) of form.media"
                :key="item.id">
                <div>
                  <el-image class="el-upload-list__item-thumbnail" style="width: 14.8rem; height: 14.8rem" :src="item.url"
                    fit="scale-down"></el-image>
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview">
                      <i class="el-icon-zoom-in" @click="onPreview(item.url)"></i>
                    </span>
                    <span class="el-upload-list__item-delete">
                      <i class="el-icon-delete" @click="onDelete(index)"></i>
                    </span>
                  </span>
                </div>
              </li>
            </ul>
            <ul v-else class="el-upload-list el-upload-list--picture-card">
              <li tabindex="0" class="el-upload-list__item is-ready media-img" v-for="(item, index) of form.media"
                :key="item.id">
                <div>
                  <video class="el-upload-list__item-thumbnail" style="width: 14.8rem; height: 14.8rem"
                    :src="item.url"></video>
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview">
                      <i class="el-icon-zoom-in" @click="onPreview(item.url)"></i>
                    </span>
                    <span class="el-upload-list__item-delete">
                      <i class="el-icon-delete" @click="onDelete(index)"></i>
                    </span>
                  </span>
                </div>
              </li>
            </ul>

            <div tabindex="0" class="media-img el-upload el-upload--picture-card" @click="onSelectMaterial">
              <i class="el-icon-plus"></i>
            </div>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="0">
            <el-button type="primary" style="width: 12rem" :loading="submitLoading" :disabled="submitLoading"
              @click="submitForm('ruleForm')">立即创建</el-button>
            <!-- <el-button plain style="width: 12rem" @click="$router.back()"
              >取消</el-button
            > -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog title="选择素材" center :visible.sync="dialogVisible">
      <div>
        <div class="header-menu">
          <div class="menu-left">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL + '/crm/FriendsTask/uploadimg'
            " :data="upParams" :before-upload="handleBeforeUpload" :on-success="handleSuccess"
              :on-error="handleError" :accept="accept" :show-file-list="false">
              <el-button type="primary" size="small" :loading="uploadLoading" :disabled="uploadLoading"
                icon="el-icon-upload2">
                本地上传
              </el-button>

              <!-- <div slot="tip" class="el-upload__tip">{{ tip }}</div> -->
            </el-upload>
          </div>
        </div>
        <div class="container">
          <el-table :data="tableData" border  tooltip-effect="dark"
            @selection-change="onSelection" @select="onSelections">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column show-overflow-tooltip label="素材" prop="url">
              <template slot-scope="scope">
                <div v-if="scope.row.type == '图片'">
                  <el-image style="height: 6rem" :src="scope.row.url" :preview-src-list="[scope.row.url]"
                    fit="scale-down"></el-image>
                </div>
                <div v-if="scope.row.type == '视频'">
                  <video style="width: 20rem; height: 11.2rem" :src="scope.row.url" controls="controls"></video>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="素材类型" prop="type" width="120"></el-table-column>
            <el-table-column label="状态" prop="status_name" width="120">
              <template slot-scope="scope">
                <el-tag  v-if="scope.row.status == 0" type="danger" size="mini">{{ scope.row.status_name }}</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 1" size="mini">{{ scope.row.status_name }}</el-tag>
                <!-- <span v-if="scope.row.status == 0" style="color: #F56C6C">
                  {{ scope.row.status_name }}
                </span>
                <span v-else-if="scope.row.status == 1" style="color: #67C23A">
                  {{ scope.row.status_name }}
                </span> -->
              </template>
            </el-table-column>
            <el-table-column prop="createtime" label="更新时间" width="200">
              <template slot-scope="scope">
                <span style="margin-left: 1rem">{{
                  scope.row.createtime
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="mini" :loading="scope.row.loading" :diabled="scope.row.loading"
                  @click="handleReplayUpload(scope.row)">重新上传</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
              :page-sizes="[10, 20, 50, 100]" @pagination="getData" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmSelect">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看素材" center :visible.sync="dialogVisibleImage">
      <div style="display: flex; justify-content: center; overflow: hidden">
        <img v-if="form.type == '链接' || form.type == '图片'" :src="currentImgSrc" />
        <video height="40rem" v-else :src="currentImgSrc" controls></video>
      </div>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople'
export default {
  name: "clientFriendTaskDetail",
  components: {
    pagination,
    rightPeople
  },
  data() {
    return {
      dialogVisibleImage: false,
      currentImgSrc: "",
      form: {
        visible_range: "0",
        name: "",
        content: "",
        media: [],
        type: "图片",
        department_list: [],
        user_list: [],
        tag_list: [],
        link_url: "",
        link_title: "",
      },

      dialogVisible: false,
      disabled: false,
      tooken: {},
      module: "",
      checkbox: false,
      options: [],
      optionsTag: [],
      typeData: [
        {
          value: "",
          label: "请选择类型",
        },
        {
          value: "图片",
          label: "图片",
        },
        {
          value: "视频",
          label: "视频",
        },
      ],
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      content: "",
      upParams: {
        type: "图片",
      },
      tip: "",
      names: [],
      uploadLoading: false,
      multipleSelection: [],

      showViewer: false,
      imageIndex: 1,
      previewSrcList: [],
      submitLoading: false,
    };
  },
  computed: {
    accept() {
      if (this.form.type == "图片" || this.form.type == "链接") {
        return ".jpg,.png";
      }
      if (this.form.type == "视频") {
        return ".mp4";
      }
      return ".jpg,.png";
    },
    rules() {
      const urlPattern = /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
      const validators = {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        media: [
          {
            required: true,
            type: "array",
            message: "请选择素材",
            trigger: "blur",
          },
        ],
        link_url: [
          { required: true, message: "请输入url链接", trigger: "blur" },
          {
            type: "url",
            message: "请输入正确的url链接",
            trigger: "blur",
          },
        ],
        link_title: [
          { required: true, message: "请输入链接标题", trigger: "blur" },
        ],
      };
      if (this.form.type == "视频" || this.form.type == "链接") {
        const validator = (rule, value, callback) => {
          if (value.length > 1) {
            callback(new Error("视频/链接类型素材只能选择1个"));
          }
          callback();
        };
        Object.assign(validators, {
          media: [
            {
              required: true,
              type: "array",
              message: "请选择素材",
              trigger: "blur",
            },
            {
              validator,
              trigger: "blur",
            },
          ],
        });
      }
      if (this.form.type == "图片") {
        const validator = (rule, value, callback) => {
          if (value.length > 9) {
            callback(new Error("图片类型素材只能选择9个"));
          }
          callback();
        };
        Object.assign(validators, {
          media: [
            {
              required: true,
              type: "array",
              message: "请选择素材",
              trigger: "blur",
            },
            {
              validator,
              trigger: "blur",
            },
          ],
        });
      }
      return validators;
    },
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    this.getDepartmentList();
    this.getLabelListUseAdmin();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onPreview(url) {
      this.dialogVisibleImage = true;
      this.currentImgSrc = url;
    },
    closeViewer() {
      this.showViewer = false;
    },
    onDelete(index) {
      this.$confirm("您确定移除该素材吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.form.media.splice(index, 1);
          this.$message({
            type: "success",
            message: "移除成功!",
          });
        })
        .catch(() => { });
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    onConfirmSelect() {
      this.form.media = this.form.media.concat(this.multipleSelection);
      this.dialogVisible = false;
    },
    onSelections(selection, row) { },
    onSelectMaterial() {
      this.dialogVisible = true;
      this.getData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    async handleReplayUpload(item) {
      item.loading = true;
      let mediaid = item.media_id;
      const { data: res } = await this.axios({
        url: "/crm/FriendsTask/uploadimg2",
        method: "POST",
        data: this.qs.stringify({
          examineCode: this.tooken.examineCode,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: item.id
        }),
        timeout: 60000,
      });
      item.loading = true
      if (res.code == 0) {
        this.$message.error(res.msg)
      }
      this.getData()
    },
    getData() {
      this.axios
        .post(
          "/crm/FriendsTask/getMaterial",
          qs.stringify({
            examineCode: this.tooken.examineCode,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            type: this.upParams.type,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            res.data.data.data.forEach((item) => {
              item.loading = false;
            });
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    onUpload() { },
    handleDelete(index, row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CircleMaterial/delMaterial",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: row.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.tableData = [];
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeTypeDialog() {
      this.getData();
    },
    async getDepartmentList() {
      const { data: res } = await this.axios({
        url: "/crm/DepartmentSet/getDepartmentList",
        method: "POST",
        data: qs.stringify({
          phone: this.tooken.phone,
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
        }),
      });
      if (res.code == 1) {
        const options = res.data;
        this._formatArray(options);
        this.options = options;
      }
    },
    _formatArray(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        element.label = element.name;
        element.value = element.id;
        if (element.children) {
          this._formatArray(element.children);
        }
      }
    },
    _formatArray2(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        element.label = element.group_name || element.tag_name;
        element.value = element.group_id || element.tag_id;
        element.children = element.child;
        if (element.child) {
          this._formatArray2(element.child);
        }
      }
    },
    async getLabelListUseAdmin() {
      const { data: res } = await this.axios({
        url: "/crm/Assistant/getLabelListUseAdmin",
        method: "POST",
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
        }),
      });
      if (res.code == 1) {
        const options = res.data;
        this._formatArray2(options);
        this.optionsTag = options;
      }
    },
    addContact() {
      this.module = "getAddressBook";
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      const userid = [];
      const user = [];
      person.map((item) => {
        userid.push(item.userid);
        user.push(item.name);
      });
      this.form.user_list = userid.join();
      this.names = user;
    },
    changeTypeContent() {
      switch (this.form.type) {
        case "图片":
        case "链接":
          this.upParams.type = "图片";
          break;
        case "视频":
          this.upParams.type = "视频";
          break;
        default:
          break;
      }
    },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          message: "上传素材过大",
          type: "error",
        });
        return false;
      }

      this.uploadLoading = true;
    },
    handleSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: "error",
        });
      } else if (response.code) {
        this.$message({
          message: response.msg,
          type: "success",
        });
        this.getData();
      }
      this.uploadLoading = false;
    },
    handleError(response) {
      this.$message({
        message: response.msg,
        type: "error",
      });
    },
    handleDownload(file) {
      console.log(file);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create_task();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async create_task() {
      try {
        this.submitLoading = true;
        let media_id = "";
        let media = this.form.media;
        if (media.length) {
          let temp = media.map((i) => {
            return i.media_id;
          });
          media_id = temp.toString();
        }
        const { data: res } = await this.axios({
          url: "/crm/FriendsTask/create_task",
          method: "POST",
          data: qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            task_name: this.form.name,
            media_id,
            content: this.form.content,
            visible_range: this.form.visible_range,
            user_list: this.form.user_list,
            department_list: this.form.department_list.toString(),
            tag_list: this.form.tag_list.toString(),
            type: this.form.type,
            link_title: this.form.link_title,
            link_url: this.form.link_url,
          }),
        });
        this.submitLoading = false;
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.$router.go(-1);
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.submitLoading = false;
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}



.main {
  border-radius: .8rem;
  background: #ffffff !important;
  padding: 4rem 2rem;
}

.form-header,
.form-content {

  padding-right: 2.2rem;
  overflow: hidden;
}


.form-footer {
  margin-top: 2rem;
}

.el-upload-list__item-thumbnail {
  width: 10rem;
  height: 10rem;
}

.tag-item {
  margin-top: 3.2rem;
  border-bottom: .1rem dashed #dddddd;
  padding-bottom: 2rem;
}

.tag-item:nth-child(1) {
  margin-top: 0;
}

.header {
  line-height: 4rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.header-menu {
  margin: 1rem 0 2rem 0;
  display: flex;
  justify-content: space-between;
}

.menu-right {
  display: inline-flex;
}

.menu-select {
  margin-right: 1.6rem;
}

.header-menu .menu-left .copy-url {
  margin-left: 2.4rem;
}

.media-img {
  margin: 0 1.2rem 1.2rem 0;
}
.el-page-header{
  position: relative;
  top: -.4rem;
}
.el-form-item{
  margin-bottom:4rem;
}

</style>
<style>
::v-deep .el-radio__inner:hover {
    border-color: #49B372 !important ;
}
</style>
